import { ApiProvider } from "@src/store/ApiProvider";
import { useEffect, useState } from "react";
import { toast } from "sonner";

export type TListingPricingSchedule = {
	Alter_Amount: number;
	Blackout_End_EST: string | null;
	Blackout_Start_EST: string | null;
	End_Date_Time_EST: string;
	End_Price: number;
	Listing_ID: number;
	Price_Cycle_Minutes: number;
	Start_Date_Time_EST: string;
	Start_Price: number;
};

type TuseListingPricingSchedule = {
	listingId?: number | null;
	isSchedulePriceEnabled?: boolean | null;
};

export const useListingPricingSchedule = ({ listingId, isSchedulePriceEnabled = true }: TuseListingPricingSchedule) => {
	const [data, setData] = useState<TListingPricingSchedule | null>(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		if (!listingId || !isSchedulePriceEnabled) {
			setData(null);
			return;
		}

		let cancelled = false;

		const load = async () => {
			try {
				setLoading(true);
				setError(null);

				const res = await ApiProvider.default.get<TListingPricingSchedule>(
					`/api/Pricing/GetListingPricingSchedule?listingId=${listingId}`,
				);

				if (!cancelled) setData(res);
			} catch {
				if (!cancelled) {
					setError("Failed to load Listing Pricing Schedule data");
					toast.error("Failed to load Listing Pricing Schedule data");
				}
			} finally {
				if (!cancelled) setLoading(false);
			}
		};

		load();

		return () => {
			cancelled = true;
		};
	}, [listingId, isSchedulePriceEnabled]);

	return { data, loading, error };
};
